<template>
  <div class="col-md-4 d-flex flex-column px-0">
    <SalesDashboardCard title="Canceled/On Hold" class-card="" @set-filter="setFilter" :selected-filter="selectedFilter" :filters="filters">
      <div slot="icon">
        <span class="dashboard-card-icon dashboard-card-icon-canc-on-hold" />
      </div>
      <div slot="body">
        <Loader v-if="loading" />
        <div v-else class="row">
          <div class="col-6 d-flex flex-column">
            <span class="job-status">Canceled</span>
            <span class="job-value">{{ canceled }}</span>
          </div>
          <div class="col-6 d-flex flex-column">
            <span class="job-status">On hold</span>
            <span class="job-value">{{ on_hold }}</span>
          </div>
        </div>
      </div>
    </SalesDashboardCard>
    <SalesDashboardCard title="Jobs for today" :with-filters="false" class-card-wrapper="bg-blue dashboard-blue">
      <div slot="body">
        <Loader v-if="loadingInProgress" />
        <div v-else class="row">
          <div class="col-6 d-flex flex-column">
            <span class="in-progress-title">Scheduled jobs</span>
            <span class="in-progress-value">{{ for_today }}</span>
          </div>
          <div class="col-6 d-flex flex-column">
            <span class="in-progress-title">Completed jobs</span>
            <span class="in-progress-value">{{ completed }}</span>
          </div>
        </div>
      </div>
    </SalesDashboardCard>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import SalesDashboardCard from '../SalesDashboardCard';
import Loader from './Loader';

const filters = [
  {
    name: 'Today',
    date: '',
    to: moment().format('YYYY-MM-DD'),
    from: moment().format('YYYY-MM-DD'),
  },
  {
    name: 'Yesterday',
    date: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
    from: moment()
      .subtract(1, 'days')
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last week',
    date: '',
    from: moment()
      .subtract(1, 'weeks')
      .weekday(1)
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'weeks')
      .weekday(7)
      .format('YYYY-MM-DD'),
  },
  {
    name: 'Last month',
    date: '',
    from: moment()
      .subtract(1, 'months')
      .startOf('month')
      .format('YYYY-MM-DD'),
    to: moment()
      .subtract(1, 'months')
      .endOf('month')
      .format('YYYY-MM-DD'),
  },
];

export default {
  components: { Loader, SalesDashboardCard },
  data() {
    return {
      selectedFilter: filters[2],
      filters,
      canceled: 0,
      on_hold: 0,
      for_today: 0,
      completed: 0,
      loading: false,
      loadingInProgress: false,
    };
  },
  watch: {
    selectedFilter() {
      this.getCanceledOrOnHoldCuntJobs();
    },
  },
  mounted() {
    this.getCanceledOrOnHoldCuntJobs();
    this.getCountJobsInProgress();
  },
  methods: {
    getCanceledOrOnHoldCuntJobs() {
      this.loading = true;
      axios
        .get(
          `/sales/count-jobs/by-status?date=${this.selectedFilter.date}&date_from=${
            this.selectedFilter.from
          }&date_to=${this.selectedFilter.to}`,
        )
        .then(res => {
          this.canceled = res.data.data.canceled;
          this.on_hold = res.data.data.on_hold;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCountJobsInProgress() {
      this.loadingInProgress = true;
      axios
        .get(`/sales/count-jobs/in-progress`)
        .then(res => {
          this.for_today = res.data.data.for_today;
          this.completed = res.data.data.completed;
        })
        .finally(() => {
          this.loadingInProgress = false;
        });
    },
    setFilter(filter) {
      this.selectedFilter = filter;
    },
  },
};
</script>

<style scoped>
.job-value {
  font-size: 20px;
  font-weight: 500;
}

.job-status {
  font-size: 12px;
  font-weight: 400;
  color: #bec0ca;
}

.in-progress-title {
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
}

.in-progress-value {
  font-size: 20px;
  font-weight: 500;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/salesDashboard/subcomponents/cards/CanceledOnHoldJobs.vue